class VwKargokuryetakip2DTO {
    id: number = 0;
    kargokuryetakip1Id?: number = null;
    orderId?: number = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    doktorId?: number = null;
    aciklama?: string = "";
    diskayit?: string = "";
    doktorAdi?: string = "";
    servisAdi?: string = "";
    hastaAdsoyad?: string = "";
    fkIptalneden?: number = null;
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
}
export default VwKargokuryetakip2DTO;